export const enum Resource {
  /**
   * 火山模型
   */
  ArkModel = 'ark_model',
  /**
   * 海外版火山模型
   */
  AbroadArkModel_SD_Fast = 'dreamina_seedance_fast',
  /**
   * 海外版火山模型
   */
  AbroadArkModel = 'abroad_ark_model',

  /**
   * Wan3 模型
   */
  Wan3Model = 'wan3_model',

  /**
   * 试验性功能
   */
  Experimental = 'experimental',

  /**
   * 超分辨率视频列表
   */
  VideoUpscalerTemplates = 'video_upscaler_templates',

  /**
   * 视频编辑
   */
  VideoEdit = 'video_edit',

  /**
   * 视频复刻
   */
  VideoReplication = 'video_replication',

  /**
   * 爆款生成
   */
  ProductAnalysis = 'product_analysis',

  /**
   * 技能包
   */
  Skill = 'skill',

  /**
   * 全局技能包
   */
  GlobalSkill = 'global_skill',

  /**
   * 部门技能包
   */
  GroupSkill = 'group_skill',

  /**
   * 素材管理相关功能
   */
  VideoAssetManagement = 'res:aigc-video:aigc-video:asset_management',

  /**
   * 视频生成相关的功能
   */
  GenerateVideo = 'res:aigc-video:aigc-video:generate_video',

  /**
   * 系统设置相关的功能
   */
  SystemSettings = 'system_settings',

  /**
   * 视频翻译功能
   */
  TranslateVideo = 'res:aigc-video:aigc-video:translate_video',
  /**
   * 智能擦除功能
   */
  SmartErase = 'smart_erase',
  /**
   * SoundView 擦除供应商权限
   */
  SoundViewSubtitleRemove = 'soundview_subtitle_remove',
  /**
   * 画质修复功能
   */
  QualityRestoration = 'quality_restoration',

  /**
   * Seedance 2.5 的模型
   */
  DoubaoSeedancePro = 'doubao_seedance_2_5',

  /**
   * 图片生成
   */
  GenerateImage = 'generate_image',

  /**
   * 图片翻译
   */
  TranslateImage = 'translate_image',

  /**
   * 查看部门列表
   */
  DepartmentList = 'department_list',
}

export const enum ResourceAction {
  /**
   * 所有操作
   */
  Any = '*',

  /**
   * 创建
   */
  Create = 'create',

  /**
   * 查看
   */
  Read = 'Read',

  /**
   * 可写权限，支持增删改之类的操作
   */
  Write = 'Write',

  /**
   * 编辑
   */
  Update = 'update',

  /**
   * 删除
   */
  Delete = 'delete',
}

/**
 * 权限
 *
 * 权限由两个部分组成，资源:动作
 */
export const enum Permission {
  火山云SD2_5模型 = `${Resource.DoubaoSeedancePro}:${ResourceAction.Read}`,
  火山云模型 = `${Resource.ArkModel}:${ResourceAction.Read}`,
  火山云模型SD_FAST = `${Resource.AbroadArkModel_SD_Fast}:${ResourceAction.Read}`,
  Wan3模型 = `${Resource.Wan3Model}:${ResourceAction.Read}`,
  海外版火山云模型 = `${Resource.AbroadArkModel}:${ResourceAction.Read}`,
  视频超分辨率 = `${Resource.VideoUpscalerTemplates}:${ResourceAction.Any}`,
  视频编辑 = `${Resource.VideoEdit}:${ResourceAction.Any}`,
  视频复刻 = `${Resource.VideoReplication}:${ResourceAction.Any}`,
  爆款生成 = `${Resource.ProductAnalysis}:${ResourceAction.Any}`,
  管理技能包 = `${Resource.Skill}:${ResourceAction.Any}`,
  查看技能包 = `${Resource.Skill}:${ResourceAction.Read}`,
  创建全局技能包 = `${Resource.GlobalSkill}:${ResourceAction.Write}`,
  创建部门技能包 = `${Resource.GroupSkill}:${ResourceAction.Write}`,
  资产管理 = `${Resource.VideoAssetManagement}:${ResourceAction.Any}`,
  视频生成 = `${Resource.GenerateVideo}:${ResourceAction.Any}`,
  系统设置 = `${Resource.SystemSettings}:${ResourceAction.Any}`,
  视频翻译 = `${Resource.TranslateVideo}:${ResourceAction.Any}`,
  智能擦除 = `${Resource.SmartErase}:${ResourceAction.Any}`,
  SoundView擦除 = `${Resource.SoundViewSubtitleRemove}:${ResourceAction.Any}`,
  画质修复 = `${Resource.QualityRestoration}:${ResourceAction.Any}`,
  图片生成 = `${Resource.GenerateImage}:${ResourceAction.Any}`,
  图片翻译 = `${Resource.TranslateImage}:${ResourceAction.Any}`,
  查看部门列表 = `${Resource.DepartmentList}:${ResourceAction.Read}`,
}
